import { IProsecutorOffice } from 'APIPackage/KnmModule/interfaces/IProsecutorOffice';
import { IUserOrganisationSelectOption } from 'CorePackage/CatalogsModule/interfaces/IUserOrganisationSelectOption';

interface IKnmProsecutorOrganization extends Omit<IProsecutorOffice, 'id' | 'name'> {
  id: string;
  name: string;
}

interface ICreateKnmProsecutorOrganizationSelectOption {
  prosecutorOrganization: IKnmProsecutorOrganization;
  districtName: IUserOrganisationSelectOption['districtName'];
  districtId: IUserOrganisationSelectOption['districtId'];
}

export const createKnmProsecutorOrganisationSelectOption = ({
  prosecutorOrganization,
  districtName,
  districtId,
}: ICreateKnmProsecutorOrganizationSelectOption): IUserOrganisationSelectOption => ({
  id: prosecutorOrganization.id,
  fullName: prosecutorOrganization.name,
  districtName,
  districtId,
  label: `${districtName ? `${districtName}, ` : ''}${prosecutorOrganization.name}`,
  value: prosecutorOrganization.id,
});
